/* ------------------------------------------------------------------ *
 * Mix & Glow custom JavaScript
 * Loaded once from layout/theme.liquid, after the theme's own scripts.
 * Single source of truth for custom client-side behavior (mirrors the
 * assets/custom.css convention). Each block is commented with what it
 * does and why.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  // The theme.liquid head snippet eager-loads this file on ?first= collection
  // landings (so the pin can run mid-parse, before DOMContentLoaded) and the
  // normal deferred tag at the bottom of <body> loads it a second time:
  // run once only.
  if (window.__mgCustomJs) return;
  window.__mgCustomJs = true;

  function initPdpEnhancements() {
    var SEL_ID = '.shopify-product-form [name="id"], form[action*="/cart/add"] [name="id"]';
    var SEL_PRICE = 'product-price [ref="priceContainer"] .price, .add-to-cart-text__suffix-price .price';

    var firstInput = document.querySelector(SEL_ID);
    if (!firstInput) return; // not a product page
    var section = firstInput.closest('.shopify-section') || document;

    // Detect the currency symbol from an existing price; default to "$".
    var symbol = '$';
    var sample = section.querySelector('product-price [ref="priceContainer"] .price');
    if (sample) {
      var m = sample.textContent.trim().match(/^([^\d\s]+)/);
      if (m && m[1]) symbol = m[1];
    }
    function money(cents) {
      return symbol + (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    // The mobile sticky add-to-cart bar renders its price with
    // `money_with_currency` (e.g. "$39.95 USD") in .update-price-content.
    // Detect the trailing currency code once so we can match that format.
    var currencyCode = null;
    (function () {
      var el = document.querySelector('.update-price-content');
      if (el) {
        var mm = el.textContent.trim().match(/([A-Za-z]{3})\s*$/);
        if (mm) currencyCode = mm[1];
      }
    })();
    function moneyWithCurrency(cents) {
      return money(cents) + (currencyCode ? ' ' + currencyCode : '');
    }

    // Product data loaded once from /products/<handle>.js
    var OPT_SEP = '~|~';
    var variants = [];
    var priceById = {};        // id -> { price, compare } in cents
    var variantByOptions = {}; // "opt1~|~opt2..." -> variant
    var loaded = false;
    var reloadingFor = null;
    var writing = false;       // guards the price observer against our own writes

    function productUrl() {
      var vp = section.querySelector ? section.querySelector('variant-picker[data-product-url]') : null;
      var u = (vp && vp.getAttribute('data-product-url')) || window.location.pathname;
      return u.split('?')[0].replace(/\/$/, '');
    }

    function loadProduct() {
      return fetch(productUrl() + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          variants = p.variants || [];
          variants.forEach(function (v) {
            priceById[String(v.id)] = { price: v.price, compare: v.compare_at_price };
            variantByOptions[v.options.join(OPT_SEP)] = v;
          });
          loaded = true;
          observePrices();
        })
        .catch(function () { /* leave native behavior untouched on failure */ });
    }

    function currentVariant() {
      var input = document.querySelector(SEL_ID);
      var id = input && input.value;
      if (!id) return null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    /* ================================================================ *
     * Feature 1: keep the DISPLAYED price in sync with the variant id
     *
     * The Color swatches and Size dropdown are rendered by the Glo Color
     * Swatch app; the theme's price only updates from the native
     * variant-picker's racy fetch/morph flow, so the shown price often
     * sticks on the previous variant. The cart is always charged
     * correctly (Glo sets the real variant id on the form), so we make
     * the display follow that id, read from local product data. A short
     * poll catches Glo's silent id write; a MutationObserver instantly
     * re-corrects when the native flow overwrites with a stale value.
     * ================================================================ */
    function enforcePrice() {
      if (!loaded || writing) return;
      var input = document.querySelector(SEL_ID);
      var id = input && input.value;
      if (!id) return;
      var data = priceById[String(id)];
      if (!data) {
        if (reloadingFor !== id) { reloadingFor = id; loadProduct(); }
        return;
      }
      // On-sale variant: let the theme render its own compare/sale markup.
      if (data.compare && data.compare > data.price) return;
      var text = money(data.price);
      var spans = section.querySelectorAll(SEL_PRICE);
      writing = true;
      spans.forEach(function (s) {
        if (s.children.length === 0 && s.textContent.trim() !== text) s.textContent = text;
      });
      // Mobile sticky add-to-cart bar price (a separate section, so query
      // document-wide). Uses the money_with_currency format.
      var stickyText = moneyWithCurrency(data.price);
      document.querySelectorAll('.update-price-content').forEach(function (el) {
        if (el.textContent.trim() !== stickyText) el.textContent = stickyText;
      });
      writing = false;
    }

    var observer = new MutationObserver(function () {
      if (writing) return;
      enforcePrice();
    });
    function observePrices() {
      section.querySelectorAll('product-price').forEach(function (pp) {
        observer.observe(pp, { childList: true, subtree: true, characterData: true });
      });
    }

    /* ================================================================ *
     * Feature 2: show each option's price inside the Glo dropdowns
     *
     * Glo renders variant option dropdowns as a custom <ul> where each
     * <li> is one option value. We append a small price to each option
     * (e.g. "Vertical 50\"x60\" - $53.95"), computed from the CURRENT
     * selection plus that option value, so it stays correct even if a
     * product ever prices variants differently per color.
     *
     * Notes:
     *  - The li's own data-variantid is NOT reliable (Glo leaves it on
     *    the first color's variant), so we compute the variant ourselves.
     *  - The price lives in its own .mg-opt-price span, and we read the
     *    option label by EXCLUDING that span. We never parse it out by
     *    text, so option values that contain " - " (e.g. birth-flower
     *    "January - Carnation") are handled correctly.
     *  - Options that aren't real variants (e.g. personalization) won't
     *    match a variant, so no price is shown. That's intended.
     * ================================================================ */
    function optionText(li) {
      var anchor = li.querySelector('.swatch-anchor') || li;
      var t = '';
      var nodes = anchor.childNodes;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.nodeType === 1 && n.classList && n.classList.contains('mg-opt-price')) continue;
        t += n.textContent || '';
      }
      return t.replace(/\s+/g, ' ').trim();
    }

    function setOptionPrice(li, text) {
      var anchor = li.querySelector('.swatch-anchor') || li;
      var el = li.querySelector('.mg-opt-price');
      if (!el) {
        el = document.createElement('span');
        el.className = 'mg-opt-price';
        el.style.cssText = 'margin-left:6px;font-variant-numeric:tabular-nums;';
        anchor.appendChild(el);
      }
      if (el.textContent !== text) el.textContent = text;
    }

    function decorateDropdowns() {
      if (!loaded) return;
      var cur = currentVariant();
      if (!cur) return;
      document.querySelectorAll('.ul-globo-dropdown-option').forEach(function (ul) {
        var lis = Array.prototype.slice.call(ul.querySelectorAll('li'));
        if (!lis.length) return;
        var liTexts = lis.map(optionText);
        // Which option position does this dropdown control? The one whose
        // current value appears among this dropdown's option labels.
        var optIndex = -1;
        for (var i = 0; i < cur.options.length; i++) {
          if (liTexts.indexOf(cur.options[i]) !== -1) { optIndex = i; break; }
        }
        if (optIndex === -1) return;
        lis.forEach(function (li, idx) {
          var val = liTexts[idx];
          var cand = cur.options.slice();
          cand[optIndex] = val;
          var v = variantByOptions[cand.join(OPT_SEP)];
          if (!v) return;
          if (v.compare_at_price && v.compare_at_price > v.price) return;
          setOptionPrice(li, '- ' + money(v.price));
        });
      });
    }

    /* ================================================================ *
     * Feature 3: lift the banner Size Guide link onto the size row
     *
     * blocks/_product_size_guide.liquid renders a "Size Guide" link (id
     * mg-size-guide-src) below the Glo size dropdown for Banner products.
     * To avoid it eating a whole row, clone it up next to the Glo
     * "Size (inches): <value>" label, right-aligned. The original stays in
     * place but hidden, so if this ever fails to find the label the link
     * still shows below the dropdown (graceful fallback). Runs on tick, so
     * it re-attaches whenever Glo re-renders the label.
     * ================================================================ */
    function placeSizeGuideLink() {
      var src = document.getElementById('mg-size-guide-src');
      if (!src) return; // not a product with the banner size-guide trigger

      function visible(el) {
        if (!el || el.offsetParent === null) return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      }

      // Already placed on the size line? keep original hidden and stop.
      var existing = document.querySelector('.mg-size-guide-inline');
      if (existing) {
        if (visible(existing)) { src.style.display = 'none'; return; }
        if (existing.parentNode) existing.parentNode.removeChild(existing);
      }

      // Glo renders the size option label as <legend class="name-option"
      // data-name="Size (inches)">Size (inches)<span class="name-variant">: value</span></legend>
      // sitting above the dropdown. Drop the link inline at the end of that legend.
      var scope = section || document;
      var legs = scope.querySelectorAll('legend.name-option');
      var leg = null;
      for (var i = 0; i < legs.length; i++) {
        if (!visible(legs[i])) continue;
        var dn = (legs[i].getAttribute('data-name') || '').trim();
        var tx = (legs[i].textContent || '').trim();
        if (dn.indexOf('Size') === 0 || tx.indexOf('Size (inches)') === 0) { leg = legs[i]; break; }
      }
      if (!leg) { src.style.display = ''; return; } // fallback: leave link visible below

      var clone = src.cloneNode(true);
      clone.removeAttribute('id');
      clone.classList.add('mg-size-guide-inline');
      // Inline, icon LEFT of text, one row, flowing right after the size text.
      clone.style.cssText = 'display:inline-flex;flex-direction:row;align-items:center;gap:5px;white-space:nowrap;margin-left:12px;vertical-align:middle;position:static;';
      var svg = clone.querySelector('svg');
      if (svg) svg.style.cssText = 'flex:0 0 auto;width:15px;height:15px;';
      leg.appendChild(clone);

      if (visible(clone)) {
        src.style.display = 'none';
      } else {
        if (clone.parentNode) clone.parentNode.removeChild(clone);
        src.style.display = '';
      }
    }

    function tick() {
      enforcePrice();
      decorateDropdowns();
      placeSizeGuideLink();
    }

    loadProduct().then(tick);

    // Glo writes the form variant id and re-renders its widgets silently
    // (no DOM event we can hook), so poll. Also react to the theme event.
    setInterval(tick, 150);
    (section.addEventListener ? section : document).addEventListener('variant:update', function () {
      setTimeout(tick, 0);
    });
  }

  /* ================================================================ *
   * Feature 4: pin the ad-clicked product to slot #1 of a collection
   * FAST PATH: if the product is already rendered on the page, move its
   *   <li> to the front (instant, no fetch).
   * SLOW PATH: if it's buried on a later page, fetch that collection page,
   *   lift the theme's real card node, and prepend it (de-duped so it
   *   doesn't show twice when the shopper scrolls to where it would load).
   * Trigger: any /collections/... URL with ?first=<handle>&variant=<id>.
   *   `first=` accepts a bare handle, a /products/<handle> path, or a full
   *   Facebook-encoded product URL (handle + variant are extracted).
   * ================================================================ */
  function initCollectionCuratedFirst() {
    if (location.pathname.indexOf('/collections/') === -1) return; // collections only
    var qp = new URLSearchParams(location.search);
    var raw = (qp.get('first') || '').trim();
    if (!raw) return;

    // Resolve target handle + optional variant from `first=`.
    var handle = '';
    var variantId = qp.get('variant') || '';
    try {
      if (raw.indexOf('http') === 0 || raw.indexOf('/products/') !== -1) {
        var u = new URL(raw, location.origin);
        var segs = u.pathname.split('/').filter(Boolean);
        var pi = segs.indexOf('products');
        if (pi !== -1 && segs[pi + 1]) handle = segs[pi + 1];
        if (!variantId) variantId = u.searchParams.get('variant') || '';
      } else {
        handle = raw.split('/').filter(Boolean).pop();
      }
    } catch (e) { handle = raw.split('/').filter(Boolean).pop(); }
    handle = (handle || '').split('?')[0].toLowerCase();
    if (!handle) return;

    // Collection handle from the path (used for the slow-path fetch).
    var collHandle = '';
    var pp = location.pathname.split('/').filter(Boolean);
    var ci = pp.indexOf('collections');
    if (ci !== -1 && pp[ci + 1]) collHandle = pp[ci + 1];

    function grid() {
      return document.querySelector('#ResultsList ul.product-grid') ||
             document.querySelector('ul.product-grid');
    }

    // Mask the grid until the pinned order is final so the shopper never
    // sees the cards shuffle. The pre-paint mask is a tiny head snippet in
    // theme.liquid (managed by theme_deploy.py) that sets the mg-pin-first
    // class BEFORE the grid paints; the style element here is a late
    // fallback in case a theme update wiped that snippet. Fast path unmasks
    // in the same tick, slow path fades the grid in already-ordered, and a
    // hard failsafe unmasks no matter what after 2.5s.
    var mask = document.createElement('style');
    mask.textContent = '.mg-pin-first ul.product-grid{opacity:0 !important}';
    (document.head || document.documentElement).appendChild(mask);
    document.documentElement.classList.add('mg-pin-first');
    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      function unmask() {
        document.documentElement.classList.remove('mg-pin-first');
        if (mask.parentNode) mask.parentNode.removeChild(mask);
      }
      var g = grid();
      if (g) {
        g.style.transition = 'opacity .18s ease';
        requestAnimationFrame(unmask);
      } else {
        unmask();
      }
    }
    function findItemIn(root) {
      var links = root.querySelectorAll('a.product-card__link[href]');
      for (var i = 0; i < links.length; i++) {
        var seg = (links[i].getAttribute('href') || '').split('?')[0].split('/products/')[1];
        if (seg && seg.split('/')[0].toLowerCase() === handle) {
          return links[i].closest('li') || links[i].closest('.product-grid__item');
        }
      }
      return null;
    }
    var variantSet = false;
    function applyVariant(item) {
      if (!(variantId && /^\d+$/.test(variantId)) || variantSet || !item) return;
      variantSet = true;
      item.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        try {
          var au = new URL(a.getAttribute('href'), location.origin);
          au.searchParams.set('variant', variantId);
          a.setAttribute('href', au.pathname + au.search);
        } catch (e) {}
      });
    }

    var already = false;
    function tryMove() {
      var g = grid(); if (!g) return false;
      var item = findItemIn(g);
      if (!item) return false;
      if (g.firstElementChild !== item) g.insertBefore(item, g.firstElementChild);
      applyVariant(item);
      already = true;
      reveal();
      return true;
    }

    var fetching = false, injected = false;
    async function tryFetchAndInject() {
      if (already || injected || fetching || !collHandle) return;
      fetching = true;
      try {
        var base = '/collections/' + encodeURIComponent(collHandle);
        function fetchPage(p) {
          return fetch(base + '?page=' + p)
            .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
        }
        // The grid's .shopify-section wrapper tells us the section id, which
        // unlocks the Section Rendering API: ~11KB gzipped per page instead
        // of the ~55KB full document. On mobile bandwidth that difference is
        // most of the wait, so prefer it and fall back to full pages.
        function sectionId() {
          var g = grid();
          var sec = g && g.closest('.shopify-section');
          return (sec && sec.id.indexOf('shopify-section-') === 0)
            ? sec.id.slice('shopify-section-'.length) : '';
        }
        async function pageHtml(p) {
          // The head snippet prefetches a section-rendered page 2 (with the
          // section id BAKED IN by theme_deploy.py) the moment the document
          // starts loading; that is normally already resolved by the time we
          // get here. Sanity-check the payload in case the baked id went
          // stale after a template change, then fall back to fetching with
          // the id read from the live DOM, then to the full page.
          if (p === 2 && window.__mgPinP2) {
            var pre = await window.__mgPinP2;
            if (pre && pre.indexOf('product-card__link') !== -1) return pre;
          }
          var sid = sectionId();
          if (sid) {
            var h = await fetch(base + '?page=' + p + '&section_id=' + encodeURIComponent(sid),
                                { priority: 'high' })
              .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
            if (h) return h;
          }
          return fetchPage(p);
        }
        // How many pages does this collection have? The grid announces it
        // (data-last-page), so no separate membership request is needed: if
        // the product isn't on any page, we reveal the grid unchanged.
        var lastPage = 10;
        var g0 = grid();
        if (g0) {
          var lp = parseInt(g0.getAttribute('data-last-page'), 10);
          if (lp > 0) lastPage = Math.min(lp, 10);
        }

        // Page through the rendered collection until the card shows up.
        for (var p = 2; p <= lastPage; p++) {
          var html = await pageHtml(p);
          if (already || injected) return; // fast path won while we were fetching
          if (!html) break;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var item = findItemIn(doc);
          if (item) {
            var g = grid(); if (!g) break;
            var imported = document.importNode(item, true);
            g.insertBefore(imported, g.firstElementChild);
            applyVariant(imported);
            injected = true;
            dedupe(imported);
            break;
          }
          if (!doc.querySelector('a.product-card__link')) break; // ran past the last page
        }
      } finally {
        fetching = false;
        reveal(); // injected, not-in-collection, or gave up: show what we have
      }
    }

    // If the shopper scrolls and the same product loads again lower down, hide
    // the later copy so it isn't shown twice.
    function dedupe(pinned) {
      var idEl = pinned.querySelector('[data-product-id]');
      var pid = idEl && idEl.getAttribute('data-product-id');
      if (!pid) return;
      var g = grid(); if (!g) return;
      var obs = new MutationObserver(function () {
        var cards = g.querySelectorAll('[data-product-id="' + pid + '"]');
        for (var i = 0; i < cards.length; i++) {
          var li = cards[i].closest('li');
          if (li && li !== pinned) li.style.display = 'none';
        }
      });
      obs.observe(g, { childList: true, subtree: true });
    }

    // When eager-loaded from the head snippet we execute while the document
    // is still parsing, so don't wait for DOMContentLoaded (on mobile that's
    // up to a second after the grid is already in the DOM): start the pin
    // work the moment the grid element exists.
    function run() {
      // Fast path once, immediately. If the product isn't on this page,
      // start the slow-path fetch RIGHT AWAY. The short poll runs in
      // parallel to catch hydration / view-transition re-renders and cards
      // that are still streaming in from the parser.
      if (!tryMove()) tryFetchAndInject();
      var t = 0;
      var iv = setInterval(function () {
        if (document.readyState !== 'loading') t++; // don't tick down while cards may still be parsing in
        if (tryMove() || t > 15) clearInterval(iv);
      }, 100);
      // Page-1 product whose card parsed in after the slow path gave up.
      document.addEventListener('DOMContentLoaded', function () { tryMove(); });
      // Failsafe: never hold the grid blank longer than this once it exists.
      setTimeout(reveal, 2500);
    }
    if (grid()) {
      run();
    } else {
      var w = setInterval(function () {
        if (grid() || document.readyState !== 'loading') { clearInterval(w); run(); }
      }, 50);
    }
  }

  /* ================================================================ *
   * Feature 5: reveal the PDP option apps in one shot
   * Glo Color Swatch and Globo Product Options render at different
   * moments (~1.9s and ~2.4s on a cold mobile load), so the options
   * area visibly pops in twice. The theme.liquid head snippet hides
   * both areas before first paint (class mg-opts-wait on <html>, 4s
   * failsafe there); here we watch for BOTH apps to finish rendering
   * and then unhide the whole area at once (0.15s fade via CSS).
   * Products with only one of the two apps reveal 1.2s after that app
   * renders; nothing waits longer than 3.5s no matter what.
   * ================================================================ */
  function initPdpOptionsReveal() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var d = document.documentElement;
    if (!d.classList.contains('mg-opts-wait')) return; // head snippet absent: stay inert
    var started = Date.now();
    function done() { d.classList.remove('mg-opts-wait'); clearInterval(iv); }
    var gloAt = 0, gpoAt = 0;
    var iv = setInterval(function () {
      var now = Date.now();
      if (!gloAt && document.querySelector('.globo-swatch-product-detail legend.name-option')) gloAt = now;
      if (!gpoAt && document.querySelector('.gpo-container input, .gpo-container textarea, .gpo-container select')) gpoAt = now;
      var onlyOneApp = (gloAt && !gpoAt && now - gloAt > 1200) ||
                       (gpoAt && !gloAt && now - gpoAt > 1200);
      if ((gloAt && gpoAt) || onlyOneApp || now - started > 3500) done();
    }, 100);
  }

  function initAll() {
    initPdpEnhancements();
    initPdpOptionsReveal();
    initCollectionCuratedFirst();
  }
  if (document.readyState === 'loading') {
    // Feature 4 starts immediately (it waits for the grid element itself,
    // which matters when this file is eager-loaded mid-parse); the PDP
    // features still wait for the full DOM.
    initCollectionCuratedFirst();
    document.addEventListener('DOMContentLoaded', function () {
      initPdpEnhancements();
      initPdpOptionsReveal();
    });
  } else {
    initAll();
  }
})();
